import styled from 'styled-components';

export const PlaceholderText = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;
